import React, { useState } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import '../styles/FloatingToolsButton.css';

const FloatingToolsButton = ({ userRole, push }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const topFunction = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const bottomFunction = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  const refreshFunction = () => {
    window.location.reload();
  };

  const navigateToSupport = () => {
    push('/support-chat');
  };

  return (
    <div 
      className={`floating-tools-slide ${isExpanded ? 'expanded' : ''}`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <div className="floating-tools-handle">
        <i className="fas fa-chevron-left"></i>
      </div>
      
      <div className="floating-tools-buttons">
        {userRole === 'ADMIN' && (
          <button
            className="tool-btn"
            onClick={navigateToSupport}
            title="Soporte Técnico"
            aria-label="Soporte Técnico"
          >
            <i className="fas fa-headphones"></i>
          </button>
        )}
        
        <button
          className="tool-btn"
          onClick={topFunction}
          title="Ir arriba"
          aria-label="Ir arriba"
        >
          <i className="fas fa-arrow-up"></i>
        </button>

        <button
          className="tool-btn"
          onClick={refreshFunction}
          title="Recargar página"
          aria-label="Recargar página"
        >
          <i className="fas fa-sync-alt"></i>
        </button>

        <button
          className="tool-btn"
          onClick={bottomFunction}
          title="Ir abajo"
          aria-label="Ir abajo"
        >
          <i className="fas fa-arrow-down"></i>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.auth.role
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FloatingToolsButton);
